// AUTO GENERATED FILE - Changes WILL be lost.
// uk - used as 'uk' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Ігровий купон",
  "product.last60-row-single": "Останній 60-та односетсетний матч НБА",
  "product.sb-english-single": "Англійський футболбет один матч",
  "product.sb-italian-single": "Італійський футболбет один матч",
  "product.sb-greek-single": "Грецький Soccerbet один матч",
  "product.sb-english-league": "Англійська футбольна ліга",
  "product.sb-italian-league": "Італійська футбольна ліга",
  "product.sb-greek-league": "Грецька футбольна ліга",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Зробити ставку",
  "betslip.clear": "Очистити всі",
  "betslip.clearResult": "Очистити",
  "betslip.noSelections": "Оберіть події для розміщення ставки",
  "betslip.notLoggedIn": "Увійдіть щоб зробити ставку",
  "betslip.refresh": "Оновити",
  "betslip.totalStake": "Сума",
  "betslip.noHistoryData": "Немає інформації за ставками",
  "betslip.openBets": "Відкриті ставки",
  "betslip.betHistory": "Історія ставок",
  "betslip.betHistoryWon": "Виграш",
  "betslip.betHistoryLost": "Програш",
  "loading.loading": "Завантаження",
  "loading.account": "Завантаження аккаунта",
  "loading.league": "Завантаження ліги",
  "loading.gameweeks": "Завантаження ігрового тижня",
  "loading.markets": "Завантаження подій",
  "loading.bethistory": "Завантаження історії ставок",
  "login.loginRequired": "Потрібен логін",
  "login.loginToBet": "Будь ласка, увійдіть щоб зробити ставку",
  "navigation.back": "Повернутися",
  "navigation.close": "Закрити",
  "video.liveStreamAvailable": "Live трансляція доступна",
  "video.logInToWatch": "Будь ласка, авторизуйтесь для перегляду",
  "error.error": "Помилка",
  "error.404": "Сторінку не знайдено",
  "error.gameLaunchFailed": "Неможливо запустити гру",
  "error.unknownErrorCode": "Невідома помилка: {code}",
  "error.minUnitStakeLimitExceeded": "Мінімальна ставка {limit}",
  "error.maxUnitStakeLimitExceeded": "Максимальна ставка {limit}",
  "error.minTotalStakeLimitExceeded": "Мінімальна сума ставки {limit}",
  "error.maxTotalStakeLimitExceeded": "Максимальна сума ставки {limit}",
  "error.stakeInvalidMultiple": "Кол має бути кратним {multiple}",
  "error.notPlaced": "Ставка не розміщена",
  "error.wagerDisallowed": "Ставка заборонена",
  "error.errorEventIsOff": "Подія розпочалася",
  "multiplebet.Singles": "Ординар",
  "multiplebet.Doubles": "Двійники",
  "multiplebet.Trebles": "Трійники",
  "multiplebet.Accumulator": "Експрес",
  "multiplebet.Perm 4-Folds": "Система 4",
  "multiplebet.Perm 5-Folds": "Система 5",
  "multiplebet.Perm 6-Folds": "Система 6",
  "multiplebet.Perm 7-Folds": "Система 7",
  "multiplebet.Perm 8-Folds": "Система 8",
  "multiplebet.Perm 9-Folds": "Система 9",
  "error.excess_bets": "Максимум одночасних ставок {limit} на ставках; будь ласка, зніміть ставку",
  "product.sb-turkish-league": "Турецька футбольна ліга",
  "error.minBetslipLimitExceeded": "Мінімальна загальна ставка ставки становить {limit}",
  "error.maxBetslipLimitExceeded": "Максимальна загальна ставка становить {limit}",
  "error.exceededMaxPayout": "Максимальна потенційна виплата становить {limit}; Будь ласка, зменшіть свою ставку.",
  "betslip.potentialReturns": "Потенційна віддача",
  "betslip.taxDisclaimer": "Всі ваші чисті виграші оподатковуються при розрахунку ставок. Сума податку буде розраховуватися в залежності від потенційного виграшу ставки.",
  "error.maintenanceEnabled": "Сервер в даний час проходить технічне обслуговування",
  "sb-english.team.ARS": "Арсенал",
  "sb-english.team.AST": "Астон В.",
  "sb-english.team.BHA": "Брайтон",
  "sb-english.team.BOU": "Борнмут",
  "sb-english.team.BUR": "Бернлі",
  "sb-english.team.CHE": "Челсі",
  "sb-english.team.CRY": "Крістал Пелес",
  "sb-english.team.EVE": "Евертон",
  "sb-english.team.LEI": "Лестер",
  "sb-english.team.LIV": "Ліверпуль",
  "sb-english.team.MNC": "Манчестер С.",
  "sb-english.team.MNU": "Манчестер Ю.",
  "sb-english.team.NEW": "Ньюкасл",
  "sb-english.team.SOU": "Саутгемптон",
  "sb-english.team.TOT": "Тотенхем",
  "sb-english.team.WAT": "Вотфорд",
  "sb-english.team.WHU": "Вест Гем",
  "sb-english.team.WOL": "Вульвс",
  "sb-english.team.NOR": "Норвіч",
  "sb-english.team.SHU": "Шеффілд Ю.",
  "sb-english.team.LEE": "Лідс",
  "sb-english.team.FUL": "Фулхем",
  "sb-english.team.WBA": "Вест Бром",
  "nomorebets": "Прийняття ставок закрито",
  "playtime": "Час гри",
  "gameId": "ID гри",
  "noGames": "В даний момент немає доступних ігр. Будь ласка, спробуйте ще раз пізніше.",
  "Home": "Господарі",
  "Away": "Гості",
  "Visitor": "Відвідувачі",
  "soccerbet.gameWeek": "СЕЗОН",
  "soccerbet.noGameWeeks": "Немає доступних сезонів. Спробуйте ще раз найближчим часом.",
  "soccerbet.league": "Таблиця ліги",
  "soccerbet.table.name": "Команда",
  "soccerbet.table.won": "В",
  "soccerbet.table.drawn": "Н",
  "soccerbet.table.lost": "П",
  "soccerbet.table.points": "Очки",
  "market.abbr.Both Teams To Score": "ОЗ",
  "market.Both Teams To Score": "Обидві Команди Заб'ють",
  "market.Over / Under": "Більше/Менше",
  "market.Double Chance": "Подвійний Результат",
  "market.Match Result": "Результат Матчу",
  "market.Exact Goals": "Кількість Голів",
  "market.Correct Score": "Точний Рахунок",
  "market.Match Result Both Score": "Результат Матчу + Обидві Заб'ють",
  "market.Result Und/Over 1.5 Total Goals": "Результат Матчу + Тотал Більше/Менше 1.5",
  "market.Result Und/Over 2.5 Total Goals": "Результат Матчу + Тотал Більше/Менше 2.5",
  "market.Under Over 1.5 Total Goals": "Тотал Більше/Менше 1.5 голів",
  "market.Under Over 2.5 Total Goals": "Тотал Більше/Менше 2.5 голів",
  "market.Under Over 3.5 Total Goals": "Тотал Більше/Менше 3.5 голів",
  "market.Under Over 4.5 Total Goals": "Тотал Більше/Менше 4.5 голів",
  "market.Total Goals 1 To 2": "Тотал від 1 до 2 голів",
  "market.Total Goals 1 To 3": "Тотал від 1 до 3 голів",
  "market.Total Goals 1 To 4": "Тотал від 1 до 4 голів",
  "market.Total Goals 2 To 3": "Тотал від 2 до 3 голів",
  "market.Total Goals 2 To 4": "Тотал від 2 до 4 голів",
  "market.Under Over 1.5 Home Goals": "Господарі Тотал Більше/Менше 1.5 голів",
  "market.Under Over 1.5 Away Goals": "Гості Тотал Більше/Менше1.5 голів",
  "market.Home Team Exact Goals": "Господарі Кількість Голів",
  "market.Away Team Exact Goals": "Гості Кількість Голів",
  "selection.Yes": "Так",
  "selection.No": "Ні",
  "selection.1+G": "П1+Так",
  "selection.1+Ng": "П1+Ні",
  "selection.X+G": "Х+Так",
  "selection.X+Ng": "Х+Ні",
  "selection.2+G": "П2+Так",
  "selection.2+Ng": "П2+Ні",
  "selection.1+Yes": "1+Так",
  "selection.1+No": "1+Ні",
  "selection.X+Yes": "Х+Так",
  "selection.X+No": "Х+Ні",
  "selection.2+Yes": "2+Так",
  "selection.2+No": "2+Ні",
  "selection.TID_ANY_GOAL_SCORED_YES": "Г",
  "selection.TID_ANY_GOAL_SCORED_NO": "Нг",
  "selection.U": "М",
  "selection.O": "Б",
  "selection.1+O": "П1+Б",
  "selection.X+O": "Х+Б",
  "selection.2+O": "П2+Б",
  "selection.1+U": "П1+М",
  "selection.X+U": "Х+М",
  "selection.2+U": "П2+М",
  "selection.TID_HOME_WIN": "П1",
  "selection.TID_AWAY_WIN": "П2",
  "selection.TID_DRAW": "Х",
  "selection.TID_HOME_WIN_OR_DRAW": "П1/Х",
  "selection.TID_DRAW_OR_AWAY_WIN": "П2/Х",
  "selection.TID_HOME_OR_AWAY_WIN": "П1/П2",
  "sb-english.team.BRE": "Брентфорд",
  "sb-english.team.abbr.BRE": "БРЕ"
}
